import * as tslib_1 from "tslib";
import { InjectionToken } from '@angular/core';
import { HttpClient } from '@angular/common/http';
export const ConfigServiceToken = new InjectionToken('config.service');
export class ConfigService {
    constructor(http) {
        this.http = http;
    }
    load() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.config = yield this.http.get('/wdpr-web-dcl-homepage/config').toPromise();
            return this.config;
        });
    }
    getValue(key) {
        // Get value of config key:
        return this.config[key];
    }
}
